import { render, staticRenderFns } from "./LatestEventWidgetPreview.vue?vue&type=template&id=5d9d0038"
import script from "./LatestEventWidgetPreview.vue?vue&type=script&lang=js"
export * from "./LatestEventWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports